<template>
  <v-layout style="margin-top: 20px;">
  <v-panel contextual-style="primary">
    <h1 class="panel-title" slot="heading">
      Select Service Provider Account
    </h1>
    <div slot="body">

      <div class="list-group">
        <a href="#" class="list-group-item active">
        Service Provider Account
        </a>
        <a @click.prevent="selectSP(customer)" v-for="customer in $store.state.auth.managed_sps " href="#" class="list-group-item">{{ customer.sp_id }} - {{ customer.name }}</a>
      </div>

    </div>
    <div slot="footer">
    </div>
  </v-panel>
</v-layout>
</template>
<script>

/* ============
 * Login Index Page
 * ============
 *
 * Page where the user can login
 */

// import authService from './../../../services/auth';
import Vue from 'vue';
import store from './../../../store';

export default {

  data() {
    return {
    //   user: {
    //     email: null,
    //     password: null,
    //   },
    };
  },

  methods: {
    selectSP(cust) {
      if (cust && cust.sp_id) {
        store.dispatch('selectSP', cust.sp_id);
      }
      if (store.state.auth.selected_sp && store.state.auth.selected_sp.sp_id) {
        Vue.router.push({
          name: 'home.index',
        });
      }
    },
  },
  components: {
    VLayout: require('layouts/minimal/minimal.vue'),
    VPanel: require('components/panel/panel.vue'),
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?29bca0e0